















import Vue from 'vue'
import { AccountBalanceStateElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AccountBalanceStateEl',

  props: {
    templateItemData: {
      type: Object as () => AccountBalanceStateElInterface,
      required: true
    }
  }
})
